import { render, staticRenderFns } from "./PurchaseOrderVehicleCustomerInsurer.vue?vue&type=template&id=843ca7a2"
import script from "./PurchaseOrderVehicleCustomerInsurer.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderVehicleCustomerInsurer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('843ca7a2')) {
      api.createRecord('843ca7a2', component.options)
    } else {
      api.reload('843ca7a2', component.options)
    }
    module.hot.accept("./PurchaseOrderVehicleCustomerInsurer.vue?vue&type=template&id=843ca7a2", function () {
      api.rerender('843ca7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderVehicleCustomerInsurer.vue"
export default component.exports